/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useMemo, useCallback } from 'react';
import ReactSVG from 'react-svg';
import { ClickAwayListener } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import * as actionTypes from '~/store/actions/actionTypes';
// import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import { SearchIcon } from '~/assets/svgIcons';
import { filterOptions } from '~/store/reducers/historyFilterOptions';
import { PaperContainer, InputBaseContainer } from './styles';

export default function CallLogsSearch({
  // onChange,
  onClose,
}) {
  // HOOKS
  const { t } = lib.useTranslation();
  const dispatch = useDispatch();

  // STATES
  const [data, setData] = useState('');

  const handleCallBack = () => {
    // onChange('');
    onClose();
  };

  const sendRequest = useCallback(
    value => {
      dispatch({
        type: actionTypes.SET_HISTORY_FILTER_OPTIONS,
        option: filterOptions.searchFor,
        payload: value,
        extra: { resetCallItems: true },
      });
    },
    [dispatch]
  );

  const debouncedSendRequest = useMemo(() => {
    return lib._.debounce(sendRequest, 1000);
  }, [sendRequest]);

  const handleOnChange = e => {
    const inputValue = e.target.value;
    setData(inputValue);
    if (inputValue && inputValue.length > 3) {
      debouncedSendRequest(inputValue);
    }
  };

  const clearSearch = () => {
    setData('');
    debouncedSendRequest('');
  };

  return (
    <ClickAwayListener onClickAway={() => {}}>
      <PaperContainer>
        <InputBaseContainer
          autoFocus
          placeholder={t('components.callLogsSearch.placeholder')}
          inputProps={{ 'aria-label': 'Search' }}
          value={data}
          className="field"
          onChange={handleOnChange}
        />
        {data.length > 0 ? (
          <Close className="icon" onClick={clearSearch} />
        ) : (
          <ReactSVG
            onClick={handleCallBack}
            src={SearchIcon}
            className="icon"
          />
        )}
      </PaperContainer>
    </ClickAwayListener>
  );
}

CallLogsSearch.propTypes = {
  // value: lib.PropTypes.string.isRequired,
  // onChange: lib.PropTypes.func.isRequired,
  onClose: lib.PropTypes.func.isRequired,
};
